import React from 'react'
import TranslateText from '../../TranslateText'
import EntryTime from '../../PositionColumns/EntryTime'
import { Text } from '../../../../styles/reactnative'
import IPText from '../../IPText'
import { TagWrap } from './styles'
import { Tag } from 'antd'
import PCInfoDetailCell from './PCInfoDetailCell'

export const column_log = mutate => {
	return [
		{
			title: '시간',
			dataIndex: 'created_at',
			key: 'created_at',
			align: 'center',
			width: 130,
			render: (text, record) => {
				return <EntryTime time={record?.created_at} style={{ fontSize: 12 }} />
			},
		},
		{
			title: '프론트시간',
			dataIndex: 'time',
			key: 'time',
			width: 130,
			align: 'center',
			render: (text, record) => {
				try {
					const parsed = JSON.parse(record?.data)
					if (parsed?.time) {
						return <EntryTime time={parsed?.time} offset={0} style={{ fontSize: 12 }} />
					}
				} catch (e) {}
				return null
			},
		},
		// {
		// 	title: '구분',
		// 	dataIndex: 'platform',
		// 	key: 'platform',
		// 	width: 50,
		// 	align: 'left',
		// 	render: (text, record) => {
		// 		return <Text>{record?.platform == 'G' ? '해선' : '코인'}</Text>
		// 	},
		// },
		{
			title: '내역',
			dataIndex: 'log',
			key: 'log',
			align: 'left',
			render: (text, record) => {
				return (
					<div style={{ color: '#000', fontWeight: 500 }}>
						<TranslateText text={text} data={record} />
					</div>
				)
			},
		},
		{
			title: '비고',
			dataIndex: 'data',
			align: 'center',
			width: 200,
			render: (text, record) => {
				let print = <></>

				if (record?.log.includes('GT')) {
					const split = record?.data?.split(':')
					if (split?.length > 1) {
						if (split[8] == '1') {
							print = <Text>청산</Text>
						}
						if (split[8] == '2') {
							print = <Text>익절</Text>
						}
						if (split[8] == '4') {
							print = <Text>전종목청산</Text>
						}
						if (split[8] == '3') {
							print = <Text>현종목청산</Text>
						}
						if (split[8] == '6') {
							print = <Text>손절</Text>
						}
						if (split[7] == '1') {
							print = <Text>MIT</Text>
						}
						if (split[7] == '10') {
							print = <Text>F10</Text>
						}
						if (split[7] == '11') {
							print = <Text>F11</Text>
						}
					}
				} else if (record?.log.includes('MIT')) {
					print = <Text>MIT실행</Text>
				}

				try {
					const parsed = JSON.parse(record?.data)

					let num = ''
					if (parsed?.f) {
						num = ' #' + parsed?.f
					}

					if (parsed?.window) {
						print = (
							<>
								{print}
								<Tag color="orange">
									{parsed?.window}
									{num}
								</Tag>
							</>
						)
					} else {
						if (num) {
							print = (
								<>
									{print}
									<Tag color="orange">{num}번창</Tag>
								</>
							)
						}
					}

					let version = <></>

					if (parsed?.version) {
						version = (
							<Tag color="green" style={{ maxWidth: 50 }}>
								v{parsed?.version}
							</Tag>
						)
					}

					if (parsed?.isMobile || parsed?.device == 'MTS') {
						return (
							<TagWrap>
								{version}
								<Tag color="red" style={{ maxWidth: 50 }}>
									모바일
								</Tag>
								{print}
							</TagWrap>
						)
					} else if (parsed?.device == 'HTS') {
						return (
							<TagWrap>
								{version}
								<Tag color="blue" style={{ maxWidth: 50 }}>
									HTS
								</Tag>
								{print}
							</TagWrap>
						)
					}

					return (
						<TagWrap>
							{version}
							{print}
						</TagWrap>
					)
				} catch (e) {
					return (
						<TagWrap>
							{print}
							<Text>{!print && text}</Text>
						</TagWrap>
					)
				}
			},
		},
		{
			title: '아이피',
			dataIndex: 'ip',
			key: 'ip',
			align: 'center',
			width: 150,
			render: (text, record) => {
				return <IPText ip={text} mutate={mutate} />
			},
		},

		{
			title: '상세',
			dataIndex: 'data',
			key: 'data',
			align: 'left',
			width: 150,
			render: (text, record) => {
				return <PCInfoDetailCell text={text} record={record} />
			},
		},
	]
}
